<template>
    <div v-if="entry" class="audition-detail-panel">
        <div class="panel-title">
            <span class="title-text">{{ entry.title }}</span>
            <span v-if="entry.isTop === 1" class="entry-badge top">置顶</span>
            <span v-if="entry.isFeatured === 1" class="entry-badge featured">加精</span>
            <span v-if="entry.badge" class="badge-honor">{{ entry.badge }}</span>
        </div>

        <div class="detail-grid">
            <div class="detail-item">
                <span class="label">创作者</span>
                <span class="value">{{ entry.userName || '-' }}</span>
            </div>
            <div class="detail-item">
                <span class="label">彩种</span>
                <span class="value">{{ preTypeLabel }}</span>
            </div>
            <div class="detail-item">
                <span class="label">彩票期号</span>
                <span class="value">{{ entry.issueNumber || '-' }}</span>
            </div>
            <div class="detail-item">
                <span class="label">注数</span>
                <span class="value" :class="{ 'audition-cell-empty': entry.betCount == null }">
                    {{ entry.betCount != null ? entry.betCount : '-' }}
                </span>
            </div>
            <div class="detail-item">
                <span class="label">投注金额</span>
                <span
                    class="value"
                    :class="entry.betAmount != null ? 'detail-em' : 'audition-cell-empty'">
                    {{ entry.betAmount != null ? entry.betAmount + ' 元' : '-' }}
                </span>
            </div>
            <div class="detail-item">
                <span class="label">预期奖金</span>
                <span
                    class="value"
                    :class="entry.expectedPrize != null ? 'detail-em' : 'audition-cell-empty'">
                    {{ formatMoney(entry.expectedPrize) }}
                </span>
            </div>
            <div class="detail-item">
                <span class="label">往期累计</span>
                <span class="value" :class="{ 'audition-cell-empty': isEmpty(entry.totalScore) }">
                    {{ formatScore(entry.totalScore) }}
                </span>
            </div>
            <div class="detail-item">
                <span class="label">本期命中</span>
                <span class="value" :class="{ 'audition-cell-empty': entry.redHitCount == null }">
                    {{ entry.redHitCount != null ? entry.redHitCount + ' 个' : '-' }}
                </span>
            </div>
            <div class="detail-item">
                <span class="label">本期积分</span>
                <span class="value" :class="{ 'audition-cell-empty': isEmpty(entry.periodScore) }">
                    {{ formatScore(entry.periodScore) }}
                </span>
            </div>
            <div class="detail-item span-all">
                <span class="label">提交时间</span>
                <span class="value" :class="{ 'audition-cell-empty': !entry.createTime }">
                    {{ entry.createTime || '-' }}
                </span>
            </div>
        </div>

        <div class="detail-section">
            <div class="section-label">预期收益分析</div>
            <div class="text-block">{{ entry.profitAnalysis || '-' }}</div>
        </div>

        <div class="detail-section">
            <div class="section-label">投注内容</div>
            <div class="bet-content-wrap">
                <audition-bet-content
                    :bet-conditions="entry.betConditions"
                    :bet-content="entry.betContent"
                    :attachment-file-name="entry.attachmentFileName"
                    :has-attachment="!!entry.hasAttachment"
                    :pre-type="entry.preType" />
                <el-button
                    v-if="canDownload"
                    type="primary"
                    size="small"
                    plain
                    class="download-btn"
                    :loading="downloading"
                    @click="$emit('download')">
                    下载投注文件
                </el-button>
            </div>
        </div>

        <div class="risk-tip">
            风险提示：彩票投注存在风险，本方案仅供参考，请理性投注，量力而行。
        </div>
    </div>
</template>

<script>
import AuditionBetContent from './AuditionBetContent.vue'

export default {
    name: 'EntryDetailPanel',
    components: { AuditionBetContent },
    props: {
        entry: { type: Object, default: null },
        lotteryOptions: { type: Array, default: () => [] },
        downloading: { type: Boolean, default: false }
    },
    computed: {
        preTypeLabel () {
            if (!this.entry || !this.entry.preType) return '-'
            const item = this.lotteryOptions.find(o => o.dictValue === this.entry.preType)
            return item ? item.dictLabel : this.entry.preType
        },
        canDownload () {
            if (!this.entry) return false
            return !!(this.entry.hasAttachment
                || (this.entry.betConditions && this.entry.betConditions.length)
                || (this.entry.betContent && this.entry.betContent.trim()))
        }
    },
    methods: {
        isEmpty (val) {
            return val == null || val === ''
        },
        formatScore (val) {
            if (this.isEmpty(val)) return '-'
            return Number(val).toLocaleString()
        },
        formatMoney (val) {
            if (val == null || val === '') return '-'
            return Number(val).toLocaleString() + ' 元'
        }
    }
}
</script>

<style lang="scss" scoped>
@import "../audition.scss";

.bet-content-wrap {
    min-width: 0;
}
</style>
